import BaseComponent from '../BaseComponent';

const NAME = 'SponsorPanel';

class SponsorPanel extends BaseComponent {
	constructor(element) {
		super(element);
		this.startIndex = 0;
		this.visibleClass = 'is-visible';
		this.timer = 3000;
		this.pointer = this.startIndex;
		this.startAnimation();
	}

	static get NAME() {
		return NAME;
	}

	startAnimation() {
		this.addVisibleClass();
		setInterval(() => {
			this.animate();
		}, this.timer);
	}

	animate() {
		// Updating/Setting the pointer
		this.pointer++;
		if(this.pointer > this._element.children.length -1 ) {
			this.pointer = this.startIndex;
		}

		// Hiding the current visible element
		this.removeVisibleClass();

		// Makes the new element visible
		this.addVisibleClass();
	}

	addVisibleClass() {
		this.visibleElement = this._element.children[this.pointer];
		this.visibleElement.classList.add(this.visibleClass);
	}

	removeVisibleClass() {
		this.visibleElement && this.visibleElement.classList.remove(this.visibleClass);
	}


}

export default SponsorPanel;
